import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width:'100%'
    },

}